import i18n from "i18next";
import { initReactI18next } from "react-i18next";

export const API_NAME = "IddinkInlever";

const detectionOptions = {
  convertDetectedLanguage: "Iso15897",
};

i18n.use(initReactI18next).init({
  detection: detectionOptions,
  defaultNS: API_NAME,
});

export default i18n